export type MerchantDTO = {
	clientId: string;
	merchantId: string;
	merchantName: string;
	merchantLogo: string;
	status: MerchantStatus;
};

export enum MerchantStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
}
